import { render } from "./owner-info.vue?vue&type=template&id=21147cfa"
import script from "./owner-info.vue?vue&type=script&lang=js"
export * from "./owner-info.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__